export default __webpack_public_path__ + "static/media/13_thumbnail.fdba6b12.JPG";